import { Component } from 'san';
import * as _ from 'lodash';

import { IProject } from 'src/models';

import { dateFormat } from 'src/filters';
import projectService from 'src/services/project.service';
import uiService from 'src/services/ui.service';
import DatePicker from '../DatePicker/DatePicker';
import { MAX_PROJECT_ID_LEVEL } from 'src/consts';

export default class ChangeProjectsList extends Component {
    static filters = {
        dateFormat
    }

    static computed = {
        snColWidth() {
            return uiService.getSnColWidth(this.data.get('projects'));
        },
        isCheckedAll() {
            const projects = this.data.get('projects');
            const checkedProjects = _.filter(projects, { _is_checked: true });
            return checkedProjects.length > 0 && checkedProjects.length === projects.length;
        }
    }

    static components = {
      'ui-date-picker': DatePicker
    };

    constructor(options: any) {
        super(options);
    }

    initData(): {
        projects: IProject[];  // {}
        dirtyProjects: IProject[];  // {}
    } {
        return {
            projects: [],
            dirtyProjects: [],
        };
    }

    inited() {
    }

    toggleCheckProject(project: IProject) {
        project = _.cloneDeep(project);
        project._is_checked = !project._is_checked;
        this.fire('change-project', project);
    }

    toggleCheckAll() {
        const isCheckedAll = !this.data.get('isCheckedAll');
        this.fire('toggle-check-all', isCheckedAll);
    }

    toggleIsNeedReceipt(project: IProject) {
      project = _.cloneDeep(project);
      project._is_need_receipt = !project._is_need_receipt;
      this.fire('change-project', project);
    }

    // 编辑项目
    toChangeProject(project: IProject) {
        this.fire('to-change-project', project);
    }

    // 追加子项目
    toAddSubProject(project: IProject) {
        this.fire('to-add-sub-project', project);
    }

    // 追加子项目
    toDeleteProject(project: IProject) {
        this.fire('to-delete-project', project);
    }

    // 导入子项目
    toImportSubProjects(project: IProject) {
        if(!project.actions.is_can_add) {
            return;
        }
        this.fire('to-import-sub-projects', project);
        document.getElementById('uploadChildren').blur();
    }

    getProjectIsNewSync(project: IProject) {
        return projectService.getProjectIsNewSync(project);
    }

    // 最多只能创建5层项目
    getProjectIsCanAddSync(project: IProject) {
        return project.actions.is_can_add && project.id_level < MAX_PROJECT_ID_LEVEL;
    }

    getProjectStatus(project: IProject) {
        if (project.is_changeing) {
            return project.change_status;
        } else if ('流程中' === project.flow_status) {
            return '回执中';
        } else if ('取消' === project.flow_status) {
            return '已取消';
        } else if('已完成' === project.flow_status) {
            return project.flow_status;
        }
    }

    // 变更完成时间
    onEndOnChange(endOn: string, project: IProject) {
        project = _.cloneDeep(project);
        project._end_on = endOn;
        this.fire('change-project', project);
    }

    // 项目是否dirty
    getIsDirty(project: IProject):boolean {
        const changedProjects = _.filter(this.data.get('dirtyProjects'), item => {
            return !this.getProjectIsNewSync(item);
        });
        return -1 !== _.findIndex(changedProjects, { puid: project.puid });
    }
}